export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    const map = {
        'YYYY': date.getFullYear(),
        'YY': date.getFullYear().toString().slice(-2),
        'MM': ('0' + (date.getMonth() + 1)).slice(-2),
        'DD': ('0' + date.getDate()).slice(-2),
        'HH': ('0' + date.getHours()).slice(-2),
        'mm': ('0' + date.getMinutes()).slice(-2),
        'ss': ('0' + date.getSeconds()).slice(-2)
    };

    return format.replace(/(YYYY|YY|MM|DD|HH|mm|ss)/g, (matched) => {
        return map[matched];
    });
}

// 日期比较
export function formatTimeDifference(inputTime) {
    // 当前时间
    const now = new Date();

    // 将输入的字符串转换为Date对象
    const inputDate = new Date(inputTime);

    // 检查是否输入的是一个有效的日期
    if (isNaN(inputDate)) {
        return '无效的时间格式';
    }

    // 计算两个时间之间的差异（以毫秒为单位）
    const delta = now.getTime() - inputDate.getTime();

    // 根据时间差异返回不同的字符串
    if (delta < 60 * 1000) {
        return "刚刚";
    } else if (delta < 60 * 60 * 1000) {
        return Math.floor(delta / (60 * 1000)) + "分钟前";
    } else if (delta < 24 * 60 * 60 * 1000) {
        return Math.floor(delta / (60 * 60 * 1000)) + "小时前";
    } else if (delta < 30 * 24 * 60 * 60 * 1000) {
        return Math.floor(delta / (24 * 60 * 60 * 1000)) + "天前";
    } else if (delta < 12 * 30 * 24 * 60 * 60 * 1000) {
        // 大于一个月但小于一年
        return Math.ceil(delta / (30 * 24 * 60 * 60 * 1000)) + "个月前";
    } else if (delta < 2 * 365 * 24 * 60 * 60 * 1000) {
        // 大于一年但小于两年
        return Math.floor(delta / (365 * 24 * 60 * 60 * 1000)) + "年前";
    } else {
        // 如果超过两年，直接返回输入的时间字符串
        return Math.floor(delta / (365 * 24 * 60 * 60 * 1000)) + "年前";
    }
}

export const copyText = async (text) => {
    if (navigator && navigator.clipboard) {
        await navigator.clipboard.writeText(text)
        return true
    }
    // 动态创建 textarea 标签
    const textarea = document.createElement('textarea')
    // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
    textarea.readOnly = 'readonly'
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'
    textarea.style.opacity = '0'
    // 将要 copy 的值赋给 textarea 标签的 value 属性
    textarea.value = text
    // 将 textarea 插入到 body 中
    document.body.appendChild(textarea)
    // 选中值并复制
    textarea.select()
    const result = document.execCommand('Copy')
    document.body.removeChild(textarea)
    return result
}

export const myEvalFn = (fn) => {
    const Fun = Function
    return new Fun('return ' + fn)()
}